/* eslint-disable */
import throwI18nInvalidDirectionError from '../../../Errors/I18n/I18nInvalidDirection.error';

/**
 * Determine if a provided `direction` is indeed a valid `direction`
 * @export
 * @param {I18nEntityDirections} direction The `direction` to check
 * @param {string} ltr The `ltr` value
 * @param {string} rtl The `rtl` value
 * @returns {boolean} Whether or not the provided `direction` is indeed valid
 */
const i18nValidateDirection = (direction, ltr, rtl) => {
  if (direction !== ltr && direction !== rtl) {
    return throwI18nInvalidDirectionError(direction, ltr, rtl);
  }
  return true;
};

export default i18nValidateDirection;
